var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "50%",
        "append-to-body": true,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "tweetImageDiv",
          staticStyle: { height: "80vh" },
          attrs: { id: "tweetImageDiv" },
        },
        [
          _c("p", { staticClass: "title" }, [_vm._v("特推图选择")]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.adddialogVisible,
                  expression: "!adddialogVisible",
                },
              ],
            },
            [
              _vm.resourceStateList.length > 0
                ? _c("div", { staticClass: "typeList" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "div",
                          {
                            class:
                              _vm.checkResourceStateList.length ===
                              _vm.resourceStateList.length
                                ? "checkedLi"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.onlySeeOneType(
                                  _vm.checkResourceStateList.length ===
                                    _vm.resourceStateList.length
                                    ? ""
                                    : "all"
                                )
                              },
                            },
                          },
                          [_vm._v("全部")]
                        ),
                        _vm._l(_vm.resourceStateList, function (name, ind) {
                          return _c(
                            "div",
                            {
                              key: ind,
                              class:
                                _vm.checkResourceStateList.indexOf(name) != -1
                                  ? "checkedLi"
                                  : "",
                              on: {
                                click: function ($event) {
                                  return _vm.onlySeeOneType(name)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.stockTypeMap[name].typeNameSimple)
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                _vm.dialogVisible = false
                              },
                            },
                          },
                          [_vm._v("关闭")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.addTweetLink },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                _vm._l(_vm.resourceList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, attrs: { id: item.resourceId } },
                    [
                      _vm.checkResourceStateList.indexOf(item.state) != -1
                        ? _c("div", { staticClass: "resoueceList" }, [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.resourceName)),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "option",
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.allTweets && item.allTweets.length > 0
                                      ? "选择"
                                      : "添加"
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "image" },
                              _vm._l(item.tweets, function (item1, index1) {
                                return _c("div", { key: index1 }, [
                                  _c("p", [_vm._v(_vm._s(item1.word))]),
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    _vm._l(
                                      item1.picList,
                                      function (item2, index2) {
                                        return _c(
                                          "el-checkbox-group",
                                          {
                                            key: index2,
                                            staticStyle: {
                                              position: "relative",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeCheckList(
                                                  item1,
                                                  item.tweets,
                                                  index1
                                                )
                                              },
                                            },
                                            model: {
                                              value: item1.checkList,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item1,
                                                  "checkList",
                                                  $$v
                                                )
                                              },
                                              expression: "item1.checkList",
                                            },
                                          },
                                          [
                                            _c("el-image", {
                                              staticStyle: {
                                                width: "133px",
                                                height: "83px",
                                                margin: "0.1rem 0.1rem 0 0",
                                              },
                                              attrs: {
                                                src: item2,
                                                "preview-src-list":
                                                  item1.picList,
                                              },
                                            }),
                                            _c("el-checkbox", {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "0.2rem",
                                                left: "0.1rem",
                                              },
                                              attrs: { label: item2 },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ])
                              }),
                              0
                            ),
                            _c("i", {
                              staticClass: "el-icon-top",
                              staticStyle: { "font-size": "0.3rem" },
                              on: {
                                click: function ($event) {
                                  return _vm.zhiding(item)
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.adddialogVisible,
                  expression: "adddialogVisible",
                },
              ],
            },
            [
              _c("div", { staticClass: "chooseImagePage" }, [
                _c(
                  "div",
                  {
                    class: _vm.activeName == "first" ? "chooseDiv" : "",
                    on: {
                      click: function ($event) {
                        _vm.activeName = "first"
                      },
                    },
                  },
                  [_vm._v("已有特推图")]
                ),
                _c(
                  "div",
                  {
                    class: _vm.activeName == "second" ? "chooseDiv" : "",
                    on: {
                      click: function ($event) {
                        _vm.activeName = "second"
                      },
                    },
                  },
                  [_vm._v("上传新的特推图")]
                ),
              ]),
              _c("div", { staticClass: "contentDiv" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "first",
                        expression: "activeName=='first'",
                      },
                    ],
                  },
                  [
                    _c("p", { staticClass: "tipInfo" }, [
                      _vm._v(
                        "请点选您所需展示的特推图（被选中的将会在在手机和word版本的方案中显示）"
                      ),
                      _c("span", { staticClass: "tipInfoSpan" }, [
                        _vm._v("可多选"),
                      ]),
                    ]),
                    _c("p", { staticClass: "resourceName" }, [
                      _vm._v(
                        _vm._s(_vm.editObj.resourceName) +
                          "  的特色描述及特推图"
                      ),
                    ]),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.editObj.allTweets &&
                              _vm.editObj.allTweets.length == 0,
                            expression:
                              "editObj.allTweets&&editObj.allTweets.length==0",
                          },
                        ],
                        staticClass: "tipInfo1",
                      },
                      [_vm._v("暂无图片，请点击右上方“上传新的特推图”添加。")]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.editObj.allTweets &&
                              _vm.editObj.allTweets.length > 0,
                            expression:
                              "editObj.allTweets&&editObj.allTweets.length>0",
                          },
                        ],
                      },
                      _vm._l(_vm.editObj.allTweets, function (item, index) {
                        return _c("div", { key: index }, [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticStyle: { "margin-right": "0.1rem" } },
                              [
                                _c("div", [
                                  _c("i", {
                                    staticClass: "el-icon-circle-plus",
                                    staticStyle: {
                                      color: "#DB4E1A",
                                      "font-size": "0.3rem",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addOtherPic(item)
                                      },
                                    },
                                  }),
                                ]),
                                _c("div", { staticClass: "lineClass" }, [
                                  _c("div"),
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          index !=
                                          _vm.editObj.allTweets.length - 1,
                                        expression:
                                          "index!=(editObj.allTweets.length-1)",
                                      },
                                    ],
                                  }),
                                ]),
                              ]
                            ),
                            _c("div", [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-left": "0.1rem",
                                      "font-size": "0.18rem",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.word))]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "padding-bottom": "0.1rem",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "imageDiv",
                                      staticStyle: {
                                        display: "flex",
                                        width: "7.8rem",
                                        "overflow-x": "scroll",
                                      },
                                    },
                                    _vm._l(
                                      item.picList,
                                      function (item2, index2) {
                                        return _c(
                                          "el-checkbox-group",
                                          {
                                            key: index2,
                                            staticStyle: {
                                              position: "relative",
                                            },
                                            on: { change: _vm.changePicList },
                                            model: {
                                              value: item.checkList,
                                              callback: function ($$v) {
                                                _vm.$set(item, "checkList", $$v)
                                              },
                                              expression: "item.checkList",
                                            },
                                          },
                                          [
                                            _c("el-image", {
                                              key: index2,
                                              staticStyle: {
                                                width: "133px",
                                                height: "83px",
                                                margin: "0.1rem 0.1rem 0 0",
                                              },
                                              attrs: {
                                                src: item2,
                                                "preview-src-list":
                                                  item.picList,
                                              },
                                            }),
                                            _c("el-checkbox", {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "0.2rem",
                                                left: "0.1rem",
                                              },
                                              attrs: { label: item2 },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tipInfoSpan",
                                      staticStyle: { "margin-left": "0.1rem" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addOtherPic(item)
                                        },
                                      },
                                    },
                                    [_vm._v("添加")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "second",
                        expression: "activeName=='second'",
                      },
                    ],
                  },
                  [
                    _c("p", { staticClass: "resourceName" }, [
                      _vm._v(
                        _vm._s(_vm.editObj.resourceName) +
                          "  的特色描述及特推图"
                      ),
                    ]),
                    _c("el-input", {
                      staticStyle: { "margin-bottom": "0.2rem" },
                      attrs: {
                        type: "textarea",
                        rows: 4,
                        placeholder: "请在此处 输入特色描述",
                        maxlength: "200",
                        "show-word-limit": "",
                        disabled: _vm.editWord && _vm.editWord.status != 0,
                      },
                      model: {
                        value: _vm.word,
                        callback: function ($$v) {
                          _vm.word = $$v
                        },
                        expression: "word",
                      },
                    }),
                    _c("upload", {
                      ref: "upload",
                      staticStyle: { "margin-bottom": "0.2rem" },
                      attrs: { picLimit: 100 },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.activeName == "first" &&
                              _vm.editObj.allTweets &&
                              _vm.editObj.allTweets.length > 0,
                            expression:
                              "activeName=='first'&&(editObj.allTweets&&editObj.allTweets.length>0)",
                          },
                        ],
                        staticClass: "tipInfoSpan",
                        staticStyle: { "margin-right": "0.3rem" },
                      },
                      [_vm._v("已选" + _vm._s(_vm.editObj.checkNumber) + "张")]
                    ),
                    _c("el-button", { on: { click: _vm.goBack } }, [
                      _vm._v("返回"),
                    ]),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              (_vm.editObj.allTweets &&
                                _vm.editObj.allTweets.length > 0) ||
                              _vm.activeName == "second",
                            expression:
                              "(editObj.allTweets&&editObj.allTweets.length>0)||activeName=='second'",
                          },
                          {
                            name: "loading",
                            rawName: "v-loading.fullscreen.lock",
                            value: _vm.fullscreenLoading,
                            expression: "fullscreenLoading",
                            modifiers: { fullscreen: true, lock: true },
                          },
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.addTweetImage },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }